import { NavLink, Route, Routes } from "react-router-dom";
import Dashboard from "./Dashboard";
import RecipientEditor from "./RecipientEditor";
import RulesEditor from "./RulesEditor";
import IntegrationHealth from "./IntegrationHealth";
import AuditLog from "./AuditLog";
import QrCard from "./QrCard";
import Parcel2GoSandboxTest from "./Parcel2GoSandboxTest";

const TABS = [
  { to: "/admin", label: "Dashboard", end: true },
  { to: "/admin/recipient", label: "Recipient" },
  { to: "/admin/rules", label: "Rules" },
  { to: "/admin/integrations", label: "Integrations" },
  { to: "/admin/parcel2go-test", label: "Parcel2Go test" },
  { to: "/admin/audit-log", label: "Audit log" },
  { to: "/admin/qr", label: "QR code" },
];

export default function AdminApp() {
  return (
    <div style={{ minHeight: "100vh" }}>
      <header style={{ borderBottom: "1px solid var(--color-border)", background: "var(--color-surface)" }}>
        <div className="page page-wide" style={{ paddingBottom: 0, paddingTop: "var(--space-4)" }}>
          <h1 style={{ fontSize: "1.3rem" }}>Send Michael Post — Admin</h1>
          <nav style={{ display: "flex", gap: "var(--space-4)", overflowX: "auto", paddingBottom: "var(--space-3)" }}>
            {TABS.map((t) => (
              <NavLink
                key={t.to}
                to={t.to}
                end={t.end}
                style={({ isActive }) => ({
                  whiteSpace: "nowrap",
                  paddingBottom: "var(--space-2)",
                  borderBottom: isActive ? "2px solid var(--color-primary)" : "2px solid transparent",
                  color: isActive ? "var(--color-primary)" : "var(--color-text-muted)",
                  fontWeight: 600,
                  textDecoration: "none",
                })}
              >
                {t.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      <main id="main-content" className="page page-wide">
        <Routes>
          <Route index element={<Dashboard />} />
          <Route path="recipient" element={<RecipientEditor />} />
          <Route path="rules" element={<RulesEditor />} />
          <Route path="integrations" element={<IntegrationHealth />} />
          <Route path="parcel2go-test" element={<Parcel2GoSandboxTest />} />
          <Route path="audit-log" element={<AuditLog />} />
          <Route path="qr" element={<QrCard />} />
        </Routes>
      </main>
    </div>
  );
}
